import React, { useState } from 'react';
import { Modal, Input, Select, Upload, Button, message, Form } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Option } = Select;

const CreateProductModal = ({ show, onClose, onCreate, newProduct, setNewProduct, submitting }) => {
  const [fileList, setFileList] = useState([]);

  // Handle file upload
  const handleUpload = (file) => {
    setFileList([file]);
    setNewProduct({ ...newProduct, image: file });
    return false; // Prevent immediate upload
  };

  // Handle form submission
  const handleSubmit = () => {
    if (
      !newProduct.name ||
      !newProduct.description ||
      !newProduct.link ||
      !newProduct.category ||
      !newProduct.image
    ) {
      message.error('Please fill out all fields before submitting.');
      return; // Prevent form submission
    }

    onCreate();
  };

  return (
    <Modal
      title="Create New Product"
      visible={show}
      onCancel={onClose}
      onOk={() => {
        handleSubmit();
        // Clear file list after successful product creation
        if (!submitting) setFileList([]); 
      }}
      okText="Submit"
      cancelText="Cancel"
      confirmLoading={submitting} // Use confirmLoading to manage spinner
    >
      <Input
        placeholder="Product Name"
        value={newProduct.name}
        onChange={(e) => setNewProduct({ ...newProduct, name: e.target.value })}
        style={{ marginBottom: '1rem' }}
      />
      <Input
        placeholder="Description"
        value={newProduct.description}
        onChange={(e) => setNewProduct({ ...newProduct, description: e.target.value })}
        style={{ marginBottom: '1rem' }}
      />
      <Input
        placeholder="Product Link"
        value={newProduct.link}
        onChange={(e) => setNewProduct({ ...newProduct, link: e.target.value })}
        style={{ marginBottom: '1rem' }}
      />
      <Form.Item>
        <Select
          mode="tags"
          style={{ width: '100%' }}
          placeholder="Product Category"
          value={newProduct.category}
          onChange={(values) => {
            // Only take the last entered value
            const lastValue = values[values.length - 1];
            setNewProduct({ ...newProduct, category: lastValue });
          }}
          maxTagCount={1}
        />
      </Form.Item>
      
      <Upload
        beforeUpload={handleUpload}
        fileList={fileList}
        onRemove={() => {
          setFileList([]);
          setNewProduct({ ...newProduct, image: null });
        }}
      >
        <Button icon={<UploadOutlined />}>Upload Image</Button>
      </Upload>
    </Modal>
  );
};

export default CreateProductModal;
